import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { propFirmData } from '../data/propFirmDataHomepage';
import { ReviewCard } from '../components/ReviewCard';

export function Reviews() {
  const [firms, setFirms] = useState(Object.values(propFirmData));

  useEffect(() => {
    // Future enhancement: Sorting or filtering logic can be added here
  }, []);

  return (
    <>
      <Helmet>
        <title>Prop Firm Reviews | PropViper</title>
        <meta
          name="description"
          content="Read detailed reviews of the top prop trading firms. Find out features, pros, cons, and get exclusive promo codes to start your trading journey."
        />
      </Helmet>

      <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 overflow-hidden py-16 md:py-24">
        <video autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover opacity-20">
          <source src="/assets/reviews-hero.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/40 to-black/70" />
        <div className="relative z-10 container mx-auto px-4 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold text-yellow-400 leading-tight mb-4">
            Honest Reviews of Top Prop Firms
          </h1>
          <p className="text-lg text-yellow-600 max-w-2xl mx-auto">
            Read what traders really think — get insights, pros & cons, and discounts that save you money.
          </p>
        </div>
      </section>

      <section className="bg-gray-950 text-yellow-100 py-16">
        <div className="max-w-6xl mx-auto px-4 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {firms.map((firm) => (
            <ReviewCard key={firm.id} firm={firm} />
          ))}
        </div>
      </section>
    </>
  );
}

export default Reviews;
